import 'parsleyjs';
import './fixAnchorJump';

const url = `${siteurl}ajax/contactForm`;
const formElement = $('.contact-form');
const submitConfirmMessage = $('.js-submit-confirm-message');

formElement.submit(function (e) {
  e.preventDefault();
  console.log($(this).serialize());
  if (formElement.parsley().isValid()) {
    $.post(
      url,
      $(this).serialize(),
      (data) => {
        if(data.success == true)
        {
          formElement.addClass('is-hidden');
          submitConfirmMessage.removeClass('is-hidden');
          $('body, html').animate({
            scrollTop: submitConfirmMessage.offset().top - 200,
          }, 800);
        }
        else
        {
          // TODO: show proper error
          alert("Something didn't work with the recaptcha. Please try again.");
        }

      },
      'json'
    );
  }
});

